[
  {
    "name": "Afghanistan",
    "dial_code": "+93",
    "emoji": "🇦🇫",
    "code": "AF",
    "maxLength": "9"
  },
  {
    "name": "Aland Islands",
    "dial_code": "+358",
    "emoji": "🇦🇽",
    "code": "AX",
    "maxLength": "10"
  },
  {
    "name": "Albania",
    "dial_code": "+355",
    "emoji": "🇦🇱",
    "code": "AL",
    "maxLength": "9"
  },
  {
    "name": "Algeria",
    "dial_code": "+213",
    "emoji": "🇩🇿",
    "code": "DZ",
    "maxLength": "9"
  },
  {
    "name": "AmericanSamoa",
    "dial_code": "+1684",
    "emoji": "🇦🇸",
    "code": "AS",
    "maxLength": "10"
  },
  {
    "name": "Andorra",
    "dial_code": "+376",
    "emoji": "🇦🇩",
    "code": "AD",
    "maxLength": "6"
  },
  {
    "name": "Angola",
    "dial_code": "+244",
    "emoji": "🇦🇴",
    "code": "AO",
    "maxLength": "9"
  },
  {
    "name": "Anguilla",
    "dial_code": "+1264",
    "emoji": "🇦🇮",
    "code": "AI",
    "maxLength": "10"
  },
  {
    "name": "Antarctica",
    "dial_code": "+672",
    "emoji": "🇦🇶",
    "code": "AQ",
    "maxLength": "6"
  },
  {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "emoji": "🇦🇬",
    "code": "AG",
    "maxLength": "10"
  },
  {
    "name": "Argentina",
    "dial_code": "+54",
    "emoji": "🇦🇷",
    "code": "AR",
    "maxLength": "8"
  },
  {
    "name": "Armenia",
    "dial_code": "+374",
    "emoji": "🇦🇲",
    "code": "AM",
    "maxLength": "6"
  },
  {
    "name": "Aruba",
    "dial_code": "+297",
    "emoji": "🇦🇼",
    "code": "AW",
    "maxLength": "7"
  },
  {
    "name": "Australia",
    "dial_code": "+61",
    "emoji": "🇦🇺",
    "code": "AU",
    "maxLength": "9"
  },
  {
    "name": "Austria",
    "dial_code": "+43",
    "emoji": "🇦🇹",
    "code": "AT",
    "maxLength": "11"
  },
  {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "emoji": "🇦🇿",
    "code": "AZ",
    "maxLength": "9"
  },
  {
    "name": "Bahamas",
    "dial_code": "+1242",
    "emoji": "🇧🇸",
    "code": "BS",
    "maxLength": "10"
  },
  {
    "name": "Bahrain",
    "dial_code": "+973",
    "emoji": "🇧🇭",
    "code": "BH",
    "maxLength": "8"
  },
  {
    "name": "Bangladesh",
    "dial_code": "+880",
    "emoji": "🇧🇩",
    "code": "BD",
    "maxLength": "10"
  },
  {
    "name": "Barbados",
    "dial_code": "+1246",
    "emoji": "🇧🇧",
    "code": "BB",
    "maxLength": "10"
  },
  {
    "name": "Belarus",
    "dial_code": "+375",
    "emoji": "🇧🇾",
    "code": "BY",
    "maxLength": "9"
  },
  {
    "name": "Belgium",
    "dial_code": "+32",
    "emoji": "🇧🇪",
    "code": "BE",
    "maxLength": "9"
  },
  {
    "name": "Belize",
    "dial_code": "+501",
    "emoji": "🇧🇿",
    "code": "BZ",
    "maxLength": "7"
  },
  {
    "name": "Benin",
    "dial_code": "+229",
    "emoji": "🇧🇯",
    "code": "BJ",
    "maxLength": "8"
  },
  {
    "name": "Bermuda",
    "dial_code": "+1441",
    "emoji": "🇧🇲",
    "code": "BM",
    "maxLength": "10"
  },
  {
    "name": "Bhutan",
    "dial_code": "+975",
    "emoji": "🇧🇹",
    "code": "BT",
    "maxLength": "7"
  },
  {
    "name": "Bolivia, Plurinational State of",
    "dial_code": "+591",
    "emoji": "🇧🇴",
    "code": "BO",
    "maxLength": "9"
  },
  {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "emoji": "🇧🇦",
    "code": "BA",
    "maxLength": "8"
  },
  {
    "name": "Botswana",
    "dial_code": "+267",
    "emoji": "🇧🇼",
    "code": "BW",
    "maxLength": "7"
  },
  {
    "name": "Brazil",
    "dial_code": "+55",
    "emoji": "🇧🇷",
    "code": "BR",
    "maxLength": "11"
  },
  {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "emoji": "🇮🇴",
    "code": "IO",
    "maxLength": "7"
  },
  {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "emoji": "🇧🇳",
    "code": "BN",
    "maxLength": "7"
  },
  {
    "name": "Bulgaria",
    "dial_code": "+359",
    "emoji": "🇧🇬",
    "code": "BG",
    "maxLength": "9"
  },
  {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "emoji": "🇧🇫",
    "code": "BF",
    "maxLength": "8"
  },
  {
    "name": "Burundi",
    "dial_code": "+257",
    "emoji": "🇧🇮",
    "code": "BI",
    "maxLength": "8"
  },
  {
    "name": "Cambodia",
    "dial_code": "+855",
    "emoji": "🇰🇭",
    "code": "KH",
    "maxLength": "9"
  },
  {
    "name": "Cameroon",
    "dial_code": "+237",
    "emoji": "🇨🇲",
    "code": "CM",
    "maxLength": "9"
  },
  {
    "name": "Canada",
    "dial_code": "+1",
    "emoji": "🇨🇦",
    "code": "CA",
    "maxLength": "10"
  },
  {
    "name": "Cape Verde",
    "dial_code": "+238",
    "emoji": "🇨🇻",
    "code": "CV",
    "maxLength": "7"
  },
  {
    "name": "Cayman Islands",
    "dial_code": "+ 345",
    "emoji": "🇰🇾",
    "code": "KY",
    "maxLength": "7"
  },
  {
    "name": "Central African Republic",
    "dial_code": "+236",
    "emoji": "🇨🇫",
    "code": "CF",
    "maxLength": "8"
  },
  {
    "name": "Chad",
    "dial_code": "+235",
    "emoji": "🇹🇩",
    "code": "TD",
    "maxLength": "6"
  },
  {
    "name": "Chile",
    "dial_code": "+56",
    "emoji": "🇨🇱",
    "code": "CL",
    "maxLength": "9"
  },
  {
    "name": "China",
    "dial_code": "+86",
    "emoji": "🇨🇳",
    "code": "CN",
    "maxLength": "11"
  },
  {
    "name": "Christmas Island",
    "dial_code": "+61",
    "emoji": "🇨🇽",
    "code": "CX",
    "maxLength": "9"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "emoji": "🇨🇨",
    "code": "CC",
    "maxLength": "10"
  },
  {
    "name": "Colombia",
    "dial_code": "+57",
    "emoji": "🇨🇴",
    "code": "CO",
    "maxLength": "10"
  },
  {
    "name": "Comoros",
    "dial_code": "+269",
    "emoji": "🇰🇲",
    "code": "KM",
    "maxLength": "7"
  },
  {
    "name": "Congo",
    "dial_code": "+242",
    "emoji": "🇨🇬",
    "code": "CG",
    "maxLength": "9"
  },
  {
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "emoji": "🇨🇩",
    "code": "CD",
    "maxLength": "7"
  },
  {
    "name": "Cook Islands",
    "dial_code": "+682",
    "emoji": "🇨🇰",
    "code": "CK",
    "maxLength": "5"
  },
  {
    "name": "Costa Rica",
    "dial_code": "+506",
    "emoji": "🇨🇷",
    "code": "CR",
    "maxLength": "8"
  },
  {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "emoji": "🇨🇮",
    "code": "CI",
    "maxLength": "8"
  },
  {
    "name": "Croatia",
    "dial_code": "+385",
    "emoji": "🇭🇷",
    "code": "HR",
    "maxLength": "9"
  },
  {
    "name": "Cuba",
    "dial_code": "+53",
    "emoji": "🇨🇺",
    "code": "CU",
    "maxLength": "8"
  },
  {
    "name": "Cyprus",
    "dial_code": "+357",
    "emoji": "🇨🇾",
    "code": "CY",
    "maxLength": "8"
  },
  {
    "name": "Czech Republic",
    "dial_code": "+420",
    "emoji": "🇨🇿",
    "code": "CZ",
    "maxLength": "9"
  },
  {
    "name": "Denmark",
    "dial_code": "+45",
    "emoji": "🇩🇰",
    "code": "DK",
    "maxLength": "8"
  },
  {
    "name": "Djibouti",
    "dial_code": "+253",
    "emoji": "🇩🇯",
    "code": "DJ",
    "maxLength": "10"
  },
  {
    "name": "Dominica",
    "dial_code": "+1767",
    "emoji": "🇩🇲",
    "code": "DM",
    "maxLength": "10"
  },
  {
    "name": "Dominican Republic",
    "dial_code": "+1849",
    "emoji": "🇩🇴",
    "code": "DO",
    "maxLength": "10"
  },
  {
    "name": "Ecuador",
    "dial_code": "+593",
    "emoji": "🇪🇨",
    "code": "EC",
    "maxLength": "9"
  },
  {
    "name": "Egypt",
    "dial_code": "+20",
    "emoji": "🇪🇬",
    "code": "EG",
    "maxLength": "10"
  },
  {
    "name": "El Salvador",
    "dial_code": "+503",
    "emoji": "🇸🇻",
    "code": "SV",
    "maxLength": "8"
  },
  {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "emoji": "🇬🇶",
    "code": "GQ",
    "maxLength": "9"
  },
  {
    "name": "Eritrea",
    "dial_code": "+291",
    "emoji": "🇪🇷",
    "code": "ER",
    "maxLength": "7"
  },
  {
    "name": "Estonia",
    "dial_code": "+372",
    "emoji": "🇪🇪",
    "code": "EE",
    "maxLength": "8"
  },
  {
    "name": "Ethiopia",
    "dial_code": "+251",
    "emoji": "🇪🇹",
    "code": "ET",
    "maxLength": "9"
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "emoji": "🇫🇰",
    "code": "FK",
    "maxLength": "5"
  },
  {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "emoji": "🇫🇴",
    "code": "FO",
    "maxLength": "5"
  },
  {
    "name": "Fiji",
    "dial_code": "+679",
    "emoji": "🇫🇯",
    "code": "FJ",
    "maxLength": "7"
  },
  {
    "name": "Finland",
    "dial_code": "+358",
    "emoji": "🇫🇮",
    "code": "FI",
    "maxLength": "11"
  },
  {
    "name": "France",
    "dial_code": "+33",
    "emoji": "🇫🇷",
    "code": "FR",
    "maxLength": "9"
  },
  {
    "name": "French Guiana",
    "dial_code": "+594",
    "emoji": "🇬🇫",
    "code": "GF",
    "maxLength": "9"
  },
  {
    "name": "French Polynesia",
    "dial_code": "+689",
    "emoji": "🇵🇫",
    "code": "PF",
    "maxLength": "8"
  },
  {
    "name": "Gabon",
    "dial_code": "+241",
    "emoji": "🇬🇦",
    "code": "GA",
    "maxLength": "7"
  },
  {
    "name": "Gambia",
    "dial_code": "+220",
    "emoji": "🇬🇲",
    "code": "GM",
    "maxLength": "7"
  },
  {
    "name": "Georgia",
    "dial_code": "+995",
    "emoji": "🇬🇪",
    "code": "GE",
    "maxLength": "9"
  },
  {
    "name": "Germany",
    "dial_code": "+49",
    "emoji": "🇩🇪",
    "code": "DE",
    "maxLength": "10"
  },
  {
    "name": "Ghana",
    "dial_code": "+233",
    "emoji": "🇬🇭",
    "code": "GH",
    "maxLength": "9"
  },
  {
    "name": "Gibraltar",
    "dial_code": "+350",
    "emoji": "🇬🇮",
    "code": "GI",
    "maxLength": "8"
  },
  {
    "name": "Greece",
    "dial_code": "+30",
    "emoji": "🇬🇷",
    "code": "GR",
    "maxLength": "10"
  },
  {
    "name": "Greenland",
    "dial_code": "+299",
    "emoji": "🇬🇱",
    "code": "GL",
    "maxLength": "6"
  },
  {
    "name": "Grenada",
    "dial_code": "+1473",
    "emoji": "🇬🇩",
    "code": "GD",
    "maxLength": "10"
  },
  {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "emoji": "🇬🇵",
    "code": "GP",
    "maxLength": "9"
  },
  {
    "name": "Guam",
    "dial_code": "+1671",
    "emoji": "🇬🇺",
    "code": "GU",
    "maxLength": "10"
  },
  {
    "name": "Guatemala",
    "dial_code": "+502",
    "emoji": "🇬🇹",
    "code": "GT",
    "maxLength": "8"
  },
  {
    "name": "Guernsey",
    "dial_code": "+44",
    "emoji": "🇬🇬",
    "code": "GG",
    "maxLength": "10"
  },
  {
    "name": "Guinea",
    "dial_code": "+224",
    "emoji": "🇬🇳",
    "code": "GN",
    "maxLength": "9"
  },
  {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "emoji": "🇬🇼",
    "code": "GW",
    "maxLength": "9"
  },
  {
    "name": "Guyana",
    "dial_code": "+595",
    "emoji": "🇬🇾",
    "code": "GY",
    "maxLength": "7"
  },
  {
    "name": "Haiti",
    "dial_code": "+509",
    "emoji": "🇭🇹",
    "code": "HT",
    "maxLength": "8"
  },
  {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "emoji": "🇻🇦",
    "code": "VA",
    "maxLength": "10"
  },
  {
    "name": "Honduras",
    "dial_code": "+504",
    "emoji": "🇭🇳",
    "code": "HN",
    "maxLength": "8"
  },
  {
    "name": "Hong Kong",
    "dial_code": "+852",
    "emoji": "🇭🇰",
    "code": "HK",
    "maxLength": "8"
  },
  {
    "name": "Hungary",
    "dial_code": "+36",
    "emoji": "🇭🇺",
    "code": "HU",
    "maxLength": "9"
  },
  {
    "name": "Iceland",
    "dial_code": "+354",
    "emoji": "🇮🇸",
    "code": "IS",
    "maxLength": "7"
  },
  {
    "name": "India",
    "dial_code": "+91",
    "emoji": "🇮🇳",
    "code": "IN",
    "maxLength": "10"
  },
  {
    "name": "Indonesia",
    "dial_code": "+62",
    "emoji": "🇮🇩",
    "code": "ID",
    "maxLength": "11"
  },
  {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "emoji": "🇮🇷",
    "code": "IR",
    "maxLength": "11"
  },
  {
    "name": "Iraq",
    "dial_code": "+964",
    "emoji": "🇮🇷",
    "code": "IQ",
    "maxLength": "10"
  },
  {
    "name": "Ireland",
    "dial_code": "+353",
    "emoji": "🇮🇪",
    "code": "IE",
    "maxLength": "9"
  },
  {
    "name": "Isle of Man",
    "dial_code": "+44",
    "emoji": "🇮🇲",
    "code": "IM",
    "maxLength": "10"
  },
  {
    "name": "Israel",
    "dial_code": "+972",
    "emoji": "🇮🇱",
    "code": "IL",
    "maxLength": "9"
  },
  {
    "name": "Italy",
    "dial_code": "+39",
    "emoji": "🇮🇹",
    "code": "IT",
    "maxLength": "10"
  },
  {
    "name": "Jamaica",
    "dial_code": "+1876",
    "emoji": "🇯🇲",
    "code": "JM",
    "maxLength": "10"
  },
  {
    "name": "Japan",
    "dial_code": "+81",
    "emoji": "🇯🇵",
    "code": "JP",
    "maxLength": "10"
  },
  {
    "name": "Jersey",
    "dial_code": "+44",
    "emoji": "🇯🇪",
    "code": "JE",
    "maxLength": "10"
  },
  {
    "name": "Jordan",
    "dial_code": "+962",
    "emoji": "🇯🇴",
    "code": "JO",
    "maxLength": "9"
  },
  {
    "name": "Kazakhstan",
    "dial_code": "+77",
    "emoji": "🇰🇿",
    "code": "KZ",
    "maxLength": "10"
  },
  {
    "name": "Kenya",
    "dial_code": "+254",
    "emoji": "🇰🇪",
    "code": "KE",
    "maxLength": "10"
  },
  {
    "name": "Kiribati",
    "dial_code": "+686",
    "emoji": "🇰🇮",
    "code": "KI",
    "maxLength": "8"
  },
  {
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "emoji": "🇰🇵",
    "code": "KP",
    "maxLength": "13"
  },
  {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "emoji": "🇰🇷",
    "code": "KR",
    "maxLength": "8"
  },
  {
    "name": "Kuwait",
    "dial_code": "+965",
    "emoji": "🇰🇼",
    "code": "KW",
    "maxLength": "8"
  },
  {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "emoji": "🇰🇬",
    "code": "KG",
    "maxLength": "9"
  },
  {
    "name": "Laos",
    "dial_code": "+856",
    "emoji": "🇱🇦",
    "code": "LA",
    "maxLength": "9"
  },
  {
    "name": "Latvia",
    "dial_code": "+371",
    "emoji": "🇱🇻",
    "code": "LV",
    "maxLength": "8"
  },
  {
    "name": "Lebanon",
    "dial_code": "+961",
    "emoji": "🇱🇧",
    "code": "LB",
    "maxLength": "8"
  },
  {
    "name": "Lesotho",
    "dial_code": "+266",
    "emoji": "🇱🇸",
    "code": "LS",
    "maxLength": "8"
  },
  {
    "name": "Liberia",
    "dial_code": "+231",
    "emoji": "🇱🇷",
    "code": "LR",
    "maxLength": "9"
  },
  {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "emoji": "🇱🇾",
    "code": "LY",
    "maxLength": "10"
  },
  {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "emoji": "🇱🇮",
    "code": "LI",
    "maxLength": "7"
  },
  {
    "name": "Lithuania",
    "dial_code": "+370",
    "emoji": "🇱🇹",
    "code": "LT",
    "maxLength": "8"
  },
  {
    "name": "Luxembourg",
    "dial_code": "+352",
    "emoji": "🇱🇺",
    "code": "LU",
    "maxLength": "9"
  },
  {
    "name": "Macao",
    "dial_code": "+853",
    "emoji": "🇲🇴",
    "code": "MO",
    "maxLength": "8"
  },
  {
    "name": "Macedonia",
    "dial_code": "+389",
    "emoji": "🇲🇰",
    "code": "MK",
    "maxLength": "8"
  },
  {
    "name": "Madagascar",
    "dial_code": "+261",
    "emoji": "🇲🇬",
    "code": "MG",
    "maxLength": "7"
  },
  {
    "name": "Malawi",
    "dial_code": "+265",
    "emoji": "🇲🇼",
    "code": "MW",
    "maxLength": "9"
  },
  {
    "name": "Malaysia",
    "dial_code": "+60",
    "emoji": "🇲🇾",
    "code": "MY",
    "maxLength": "7"
  },
  {
    "name": "Maldives",
    "dial_code": "+960",
    "emoji": "🇲🇻",
    "code": "MV",
    "maxLength": "7"
  },
  {
    "name": "Mali",
    "dial_code": "+223",
    "emoji": "🇲🇱",
    "code": "ML",
    "maxLength": "8"
  },
  {
    "name": "Malta",
    "dial_code": "+356",
    "emoji": "🇲🇹",
    "code": "MT",
    "maxLength": "8"
  },
  {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "emoji": "🇲🇭",
    "code": "MH",
    "maxLength": "7"
  },
  {
    "name": "Martinique",
    "dial_code": "+596",
    "emoji": "🇲🇶",
    "code": "MQ",
    "maxLength": "9"
  },
  {
    "name": "Mauritania",
    "dial_code": "+222",
    "emoji": "🇲🇷",
    "code": "MR",
    "maxLength": "8"
  },
  {
    "name": "Mauritius",
    "dial_code": "+230",
    "emoji": "🇲🇺",
    "code": "MU",
    "maxLength": "8"
  },
  {
    "name": "Mayotte",
    "dial_code": "+262",
    "emoji": "🇾🇹",
    "code": "YT",
    "maxLength": "9"
  },
  {
    "name": "Mexico",
    "dial_code": "+52",
    "emoji": "🇲🇽",
    "code": "MX",
    "maxLength": "10"
  },
  {
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "emoji": "🇫🇲",
    "code": "FM",
    "maxLength": "7"
  },
  {
    "name": "Moldova",
    "dial_code": "+373",
    "emoji": "🇲🇩",
    "code": "MD",
    "maxLength": "8"
  },
  {
    "name": "Monaco",
    "dial_code": "+377",
    "emoji": "🇲🇨",
    "code": "MC",
    "maxLength": "8"
  },
  {
    "name": "Mongolia",
    "dial_code": "+976",
    "emoji": "🇲🇳",
    "code": "MN",
    "maxLength": "8"
  },
  {
    "name": "Montenegro",
    "dial_code": "+382",
    "emoji": "🇲🇪",
    "code": "ME",
    "maxLength": "8"
  },
  {
    "name": "Montserrat",
    "dial_code": "+1664",
    "emoji": "🇲🇸",
    "code": "MS",
    "maxLength": "10"
  },
  {
    "name": "Morocco",
    "dial_code": "+212",
    "emoji": "🇲🇦",
    "code": "MA",
    "maxLength": "9"
  },
  {
    "name": "Mozambique",
    "dial_code": "+258",
    "emoji": "🇲🇿",
    "code": "MZ",
    "maxLength": "12"
  },
  {
    "name": "Myanmar",
    "dial_code": "+95",
    "emoji": "🇲🇲",
    "code": "MM",
    "maxLength": "10"
  },
  {
    "name": "Namibia",
    "emoji": "🇳🇦",
    "dial_code": "+264",
    "code": "NA",
    "maxLength": "7"
  },
  {
    "name": "Nauru",
    "dial_code": "+674",
    "emoji": "🇳🇷",
    "code": "NR",
    "maxLength": "7"
  },
  {
    "name": "Nepal",
    "dial_code": "+977",
    "emoji": "🇳🇵",
    "code": "NP",
    "maxLength": "10"
  },
  {
    "name": "Netherlands",
    "dial_code": "+31",
    "emoji": "🇳🇱",
    "code": "NL",
    "maxLength": "9"
  },
  {
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "emoji": "🇧🇶",
    "code": "AN",
    "maxLength": "9"
  },
  {
    "name": "New Caledonia",
    "dial_code": "+687",
    "emoji": "🇳🇨",
    "code": "NC",
    "maxLength": "6"
  },
  {
    "name": "New Zealand",
    "dial_code": "+64",
    "emoji": "🇳🇿",
    "code": "NZ",
    "maxLength": "9"
  },
  {
    "name": "Nicaragua",
    "dial_code": "+505",
    "emoji": "🇳🇮",
    "code": "NI",
    "maxLength": "8"
  },
  {
    "name": "Niger",
    "dial_code": "+227",
    "emoji": "🇳🇪",
    "code": "NE",
    "maxLength": "8"
  },
  {
    "name": "Nigeria",
    "dial_code": "+234",
    "emoji": "🇳🇬",
    "code": "NG",
    "maxLength": "8"
  },
  {
    "name": "Niue",
    "dial_code": "+683",
    "emoji": "🇳🇺",
    "code": "NU",
    "maxLength": "4"
  },
  {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "emoji": "🇳🇫",
    "code": "NF",
    "maxLength": "6"
  },
  {
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "emoji": "🇲🇵",
    "code": "MP",
    "maxLength": "7"
  },
  {
    "name": "Norway",
    "dial_code": "+47",
    "emoji": "🇳🇴",
    "code": "NO",
    "maxLength": "8"
  },
  {
    "name": "Oman",
    "dial_code": "+968",
    "emoji": "🇴🇲",
    "code": "OM",
    "maxLength": "8"
  },
  {
    "name": "Pakistan",
    "dial_code": "+92",
    "emoji": "🇵🇰",
    "code": "PK",
    "maxLength": "10"
  },
  {
    "name": "Palau",
    "dial_code": "+680",
    "emoji": "🇵🇼",
    "code": "PW",
    "maxLength": "7"
  },
  {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "emoji": "🇵🇸",
    "code": "PS",
    "maxLength": "9"
  },
  {
    "name": "Panama",
    "dial_code": "+507",
    "emoji": "🇵🇦",
    "code": "PA",
    "maxLength": "8"
  },
  {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "emoji": "🇵🇬",
    "code": "PG",
    "maxLength": "8"
  },
  {
    "name": "Paraguay",
    "dial_code": "+595",
    "emoji": "🇵🇾",
    "code": "PY",
    "maxLength": "9"
  },
  {
    "name": "Peru",
    "dial_code": "+51",
    "emoji": "🇵🇪",
    "code": "PE",
    "maxLength": "9"
  },
  {
    "name": "Philippines",
    "dial_code": "+63",
    "emoji": "🇵🇭",
    "code": "PH",
    "maxLength": "10"
  },
  {
    "name": "Pitcairn",
    "dial_code": "+872",
    "emoji": "🇵🇳",
    "code": "PN",
    "maxLength": "9"
  },
  {
    "name": "Poland",
    "dial_code": "+48",
    "emoji": "🇵🇱",
    "code": "PL",
    "maxLength": "9"
  },
  {
    "name": "Portugal",
    "dial_code": "+351",
    "emoji": "🇵🇹",
    "code": "PT",
    "maxLength": "9"
  },
  {
    "name": "Puerto Rico",
    "dial_code": "+1939",
    "emoji": "🇵🇷",
    "code": "PR",
    "maxLength": "10"
  },
  {
    "name": "Qatar",
    "dial_code": "+974",
    "emoji": "🇶🇦",
    "code": "QA",
    "maxLength": "8"
  },
  {
    "name": "Romania",
    "dial_code": "+40",
    "emoji": "🇷🇴",
    "code": "RO",
    "maxLength": "10"
  },
  {
    "name": "Russia",
    "dial_code": "+7",
    "emoji": "🇷🇺",
    "code": "RU",
    "maxLength": "10"
  },
  {
    "name": "Rwanda",
    "dial_code": "+250",
    "emoji": "🇷🇼",
    "code": "RW",
    "maxLength": "9"
  },
  {
    "name": "Reunion",
    "dial_code": "+262",
    "emoji": "🇷🇪",
    "code": "RE",
    "maxLength": "10"
  },
  {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "emoji": "🇧🇱",
    "code": "BL",
    "maxLength": "9"
  },
  {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "emoji": "🇸🇭",
    "code": "SH",
    "maxLength": "4"
  },
  {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "emoji": "🇰🇳",
    "code": "KN",
    "maxLength": "10"
  },
  {
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "emoji": "🇱🇨",
    "code": "LC",
    "maxLength": "7"
  },
  {
    "name": "Saint Martin",
    "dial_code": "+590",
    "emoji": "🇲🇫",
    "code": "MF",
    "maxLength": "6"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "emoji": "🇵🇲",
    "code": "PM",
    "maxLength": "6"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "emoji": "🇻🇨",
    "code": "VC",
    "maxLength": "7"
  },
  {
    "name": "Samoa",
    "dial_code": "+685",
    "emoji": "🇼🇸",
    "code": "WS",
    "maxLength": "7"
  },
  {
    "name": "San Marino",
    "dial_code": "+378",
    "emoji": "🇸🇲",
    "code": "SM",
    "maxLength": "10"
  },
  {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "emoji": "🇸🇹",
    "code": "ST",
    "maxLength": "7"
  },
  {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "emoji": "🇸🇦",
    "code": "SA",
    "maxLength": "9"
  },
  {
    "name": "Senegal",
    "dial_code": "+221",
    "emoji": "🇸🇳",
    "code": "SN",
    "maxLength": "9"
  },
  {
    "name": "Serbia",
    "dial_code": "+381",
    "emoji": "🇷🇸",
    "code": "RS",
    "maxLength": "9"
  },
  {
    "name": "Seychelles",
    "dial_code": "+248",
    "emoji": "🇸🇨",
    "code": "SC",
    "maxLength": "7"
  },
  {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "emoji": "🇸🇱",
    "code": "SL",
    "maxLength": "8"
  },
  {
    "name": "Singapore",
    "dial_code": "+65",
    "emoji": "🇸🇬",
    "code": "SG",
    "maxLength": "8"
  },
  {
    "name": "Slovakia",
    "dial_code": "+421",
    "emoji": "🇸🇰",
    "code": "SK",
    "maxLength": "9"
  },
  {
    "name": "Slovenia",
    "dial_code": "+386",
    "emoji": "🇸🇮",
    "code": "SI",
    "maxLength": "9"
  },
  {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "emoji": "🇸🇧",
    "code": "SB",
    "maxLength": "7"
  },
  {
    "name": "Somalia",
    "dial_code": "+252",
    "emoji": "🇸🇴",
    "code": "SO",
    "maxLength": "9"
  },
  {
    "name": "South Africa",
    "dial_code": "+27",
    "emoji": "🇿🇦",
    "code": "ZA",
    "maxLength": "9"
  },
  {
    "name": "South Sudan",
    "dial_code": "+211",
    "emoji": "🇸🇸",
    "code": "SS",
    "maxLength": "7"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "emoji": "🇬🇸",
    "code": "GS",
    "maxLength": "5"
  },
  {
    "name": "Spain",
    "dial_code": "+34",
    "emoji": "🇪🇸",
    "code": "ES",
    "maxLength": "9"
  },
  {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "emoji": "🇱🇰",
    "code": "LK",
    "maxLength": "7"
  },
  {
    "name": "Sudan",
    "dial_code": "+249",
    "emoji": "🇸🇩",
    "code": "SD",
    "maxLength": "7"
  },
  {
    "name": "Suriname",
    "dial_code": "+597",
    "emoji": "🇸🇷",
    "code": "SR",
    "maxLength": "7"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "emoji": "🇸🇯",
    "code": "SJ",
    "maxLength": "8"
  },
  {
    "name": "Swaziland",
    "dial_code": "+268",
    "emoji": "🇸🇿",
    "code": "SZ",
    "maxLength": "8"
  },
  {
    "name": "Sweden",
    "dial_code": "+46",
    "emoji": "🇸🇪",
    "code": "SE",
    "maxLength": "7"
  },
  {
    "name": "Switzerland",
    "dial_code": "+41",
    "emoji": "🇨🇭",
    "code": "CH",
    "maxLength": "9"
  },
  {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "emoji": "🇸🇾",
    "code": "SY",
    "maxLength": "7"
  },
  {
    "name": "Taiwan",
    "dial_code": "+886",
    "emoji": "🇹🇼",
    "code": "TW",
    "maxLength": "9"
  },
  {
    "name": "Tajikistan",
    "dial_code": "+992",
    "emoji": "🇹🇯",
    "code": "TJ",
    "maxLength": "9"
  },
  {
    "name": "Tanzania, United Republic of Tanzania",
    "dial_code": "+255",
    "emoji": "🇹🇿",
    "code": "TZ",
    "maxLength": "7"
  },
  {
    "name": "Thailand",
    "dial_code": "+66",
    "emoji": "🇹🇭",
    "code": "TH",
    "maxLength": "9"
  },
  {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "emoji": "🇹🇱",
    "code": "TL",
    "maxLength": "7"
  },
  {
    "name": "Togo",
    "dial_code": "+228",
    "emoji": "🇹🇬",
    "code": "TG",
    "maxLength": "8"
  },
  {
    "name": "Tokelau",
    "dial_code": "+690",
    "emoji": "🇹🇰",
    "code": "TK",
    "maxLength": "5"
  },
  {
    "name": "Tonga",
    "dial_code": "+676",
    "emoji": "🇹🇴",
    "code": "TO",
    "maxLength": "5"
  },
  {
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "emoji": "🇹🇹",
    "code": "TT",
    "maxLength": "7"
  },
  {
    "name": "Tunisia",
    "dial_code": "+216",
    "emoji": "🇹🇳",
    "code": "TN",
    "maxLength": "8"
  },
  {
    "name": "Turkey",
    "dial_code": "+90",
    "emoji": "🇹🇷",
    "code": "TR",
    "maxLength": "11"
  },
  {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "emoji": "🇹🇲",
    "code": "TM",
    "maxLength": "8"
  },
  {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "emoji": "🇹🇨",
    "code": "TC",
    "maxLength": "10"
  },
  {
    "name": "Tuvalu",
    "dial_code": "+688",
    "emoji": "🇹🇻",
    "code": "TV",
    "maxLength": "5"
  },
  {
    "name": "Uganda",
    "dial_code": "+256",
    "emoji": "🇺🇬",
    "code": "UG",
    "maxLength": "7"
  },
  {
    "name": "Ukraine",
    "dial_code": "+380",
    "emoji": "🇺🇦",
    "code": "UA",
    "maxLength": "9"
  },
  {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "emoji": "🇦🇪",
    "code": "AE",
    "maxLength": "9"
  },
  {
    "name": "United Kingdom",
    "dial_code": "+44",
    "emoji": "🇬🇧",
    "code": "GB",
    "maxLength": "10"
  },
  {
    "name": "United States",
    "dial_code": "+1",
    "emoji": "🇺🇸",
    "code": "US",
    "maxLength": "10"
  },
  {
    "name": "Uruguay",
    "dial_code": "+598",
    "emoji": "🇺🇾",
    "code": "UY",
    "maxLength": "8"
  },
  {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "emoji": "🇺🇿",
    "code": "UZ",
    "maxLength": "9"
  },
  {
    "name": "Vanuatu",
    "dial_code": "+678",
    "emoji": "🇻🇺",
    "code": "VU",
    "maxLength": "5"
  },
  {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "emoji": "🇻🇪",
    "code": "VE",
    "maxLength": "7"
  },
  {
    "name": "Vietnam",
    "dial_code": "+84",
    "emoji": "🇻🇳",
    "code": "VN",
    "maxLength": "9"
  },
  {
    "name": "Virgin Islands, British",
    "dial_code": "+1284",
    "emoji": "🇻🇬",
    "code": "VG",
    "maxLength": "7"
  },
  {
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1340",
    "emoji": "🇻🇮",
    "code": "VI",
    "maxLength": "10"
  },
  {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "emoji": "🇼🇫",
    "code": "WF",
    "maxLength": "6"
  },
  {
    "name": "Yemen",
    "dial_code": "+967",
    "emoji": "🇾🇪",
    "code": "YE",
    "maxLength": "9"
  },
  {
    "name": "Zambia",
    "dial_code": "+260",
    "emoji": "🇿🇲",
    "code": "ZM",
    "maxLength": "9"
  },
  {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "emoji": "🇿🇼",
    "code": "ZW",
    "maxLength": "9"
  }
]